import React, { Component } from 'react'
import Button from '../button/FulcrumButton'
import { Menu } from 'react-toolbox/lib/menu'
import CSSModules from 'react-css-modules'
import styles from './MenuButton.scss'

class MenuButton extends Component {
  constructor(props) {
    super(props)
    this.state = {
      active: false
    }
  }

  handleButtonClick(event) {
    this.setState({ active: !this.state.active })
    if (this.props.onClick) this.props.onClick(event)
  }

  handleMenuHide() {
    this.setState({ active: false })
    if (this.props.onHide) this.props.onHide()
  }

  render() {
    return (
      <div styleName='wrapper'>
        <div className={this.props.className}>
          <Button
            theme={this.props.theme}
            icon={this.props.icon}
            onClick={(event) => this.handleButtonClick(event)}
            ripple={this.props.iconRipple}
            label={this.props.label}
            raised={this.props.raised}
            primary={this.props.primary}
            className={this.props.className}
          />
        </div>
        <Menu
          ref='menu'
          active={this.state.active}
          onHide={() => this.handleMenuHide()}
          onSelect={this.props.onSelect}
          onShow={this.props.onShow}
          position={this.props.position}
          ripple={this.props.menuRipple}
          selectable={this.props.selectable}
          selected={this.props.selected}
          theme={this.props.theme}
        >
          {this.props.children}
        </Menu>
      </div>
    )
  }
}

export default CSSModules(MenuButton, styles)
